<template>
    <div>
        <query-tag/>
        <rev-card-container :reviewables="reviewables"></rev-card-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import { InfiniteScroll } from '../mixins/ui'
    import { ReviewableQuerys } from '../mixins/querys'
    import { GetReviewables } from '../mixins/reviewables'

    export default {
        mixins: [InfiniteScroll, ReviewableQuerys, GetReviewables],
        data() {
            return {
                name: this.$route.params.name,
            }
        },
        watch: {
            '$route'(to, from){
                // watch to see if router has changed, eg. a query like user - update update name
                // console.log('to.query', to.query)

                // from mixin
                this.GetReviewables()
            }
        },
        methods: {
        },
        mounted() {
        },
    }
</script>
